import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled(Link)`
  color: ${(props) =>
    props.color === 'white' ? 'white' : props.theme.colors.primary};
  font-size: 1.4rem;
  position: absolute;
  top: 32px;
  left: 32px;
  transition: all 200ms;

  &:hover {
    transform: scale(1.4);
  }
`;
